import * as React from "react";

import dynamic from "next/dynamic";
import { FieldValues } from "react-hook-form";

import { OutlinedTextFieldWysiwygProps, OutlinedTextFieldWysiwygRef } from "./type";

const OutlinedTextFieldWysiwygSsr = dynamic(() => import("./OutlinedTextFieldWysiwygSsr"), { ssr: false });

function OutlinedTextFieldWysiwygInternal<T extends FieldValues>(
  props: OutlinedTextFieldWysiwygProps<T>,
  ref: React.Ref<OutlinedTextFieldWysiwygRef>
): React.ReactElement<OutlinedTextFieldWysiwygProps<T>> {
  const [toggleTemplateMenu, setToggleTemplateMenu] = React.useState(false);

  React.useImperativeHandle(
    ref,
    () => ({
      openTemplateMenu: () => {
        // Since it's dynamically imported, we can't use the ref directly
        setTimeout(() => {
          setToggleTemplateMenu(true);
          setTimeout(() => {
            setToggleTemplateMenu(false);
          }, 0);
        }, 100);
      },
    }),
    []
  );

  return <OutlinedTextFieldWysiwygSsr {...props} toggleTemplateMenu={toggleTemplateMenu} ref={ref} />;
}

export const OutlinedTextFieldWysiwyg = React.forwardRef(OutlinedTextFieldWysiwygInternal) as <T extends FieldValues>(
  props: OutlinedTextFieldWysiwygProps<T> & { ref?: React.Ref<OutlinedTextFieldWysiwygRef> }
) => ReturnType<typeof OutlinedTextFieldWysiwygInternal>;
